<template>
	<v-dialog v-model="dadosCompraDialog" max-width="400">
		<v-card>
			<v-card-title >
				<p class="descricaoItem ma-0 pa-0">Pedido Finalizado</p>
				<v-spacer />
				<v-icon @click="dialogWhatsAppClose()" color="primary">mdi-close</v-icon>
			</v-card-title>
			<v-card-text class="subtitle-1 pb-3" style="text-align: justify;">
				Seu pedido é o número <strong>{{ this.idPedido }}</strong
				>, você pode entrar em contato com a gente atráves do botão abaixo.
			</v-card-text>

			<v-btn  color="#25D366" class="ml-5 mb-5 mt-0 white--text" @click="whatsapp()"> <v-icon color="white"> mdi-whatsapp</v-icon> <strong>Chamar no WhatsApp</strong>  </v-btn>
			<v-btn v-if="empresa.pdf" color="red" class="ml-5 mb-5 mt-0 white--text" @click="pdf()"> <v-icon color="white"> mdi-file-pdf-box</v-icon></v-btn>
		</v-card>
	</v-dialog>
</template>
<script>
import { mapGetters } from 'vuex'
import whatsapp from './whatsapp'
import pdf from './pdf'

export default {
	props: {
		dialogDadosCompra: Boolean,
	},
	computed: {
		...mapGetters({
			idPedido: 'idPedido',
			empresa: 'empresa',
		}),
		dadosCompraDialog: {
			get() {
				return this.dialogDadosCompra
			},
			set() {
				this.dialogWhatsAppClose()
			},
		},
	},
	methods: {
		click() {
			this.dialogWhatsAppClose()
		},
		dialogWhatsAppClose() {
			this.$emit('dialogWhatsAppClose')
		},
		whatsapp() {
			whatsapp()
		},
		pdf() {
			pdf()
		},
	},
}
</script>

<style scoped>
.descricaoItem {
	font-weight: bold;
	color: var(--v-primary-base);
}

</style>
